<template>
  <!-- Header -->
  <header id="header" class="bg-gray-700">
    <nav class="container mx-auto flex justify-start items-center py-5 px-4">
      <!-- App Name -->
      <router-link class="text-white font-bold uppercase text-2xl mr-4"
        :to="{name: 'home'}" exact-active-class="no-active">
      <!-- the router library prioritizes this class (exact-active-class) over the global class -->
        Care On Wheels
      </router-link>

      <div class="flex flex-grow items-center">
        <!-- Primary Navigation -->
        <ul class="flex flex-row mt-1">
          <!-- <li>
            <router-link class="px-2 text-white" :to="{name: 'about'}">
              About</router-link>
            </li> -->
          <li>
          </li>
          <li v-if="!userLoggedIn">
            <a class="px-2 text-white" href="#" @click.prevent="toggleAuthModal">
              Login / Register</a>
          </li>
          <template v-else> <!-- help render multipl list items -->
            <li>
              <a class="px-2 text-white" href="#" @click.prevent="signout">
                 Logout</a>
            </li>
          </template>
        </ul>

        <!-- translation menu on the right side(ml-auto-class) -->
        <!-- <ul class="flex flex-row mt-1 ml-auto">
          <li>
            <a class="px-2 text-white" href="#" @click.prevent="changeLocale">
              {{ currenctLocale }}
            </a>
          </li>
        </ul> -->
      </div>
    </nav>
  </header>
</template>

<script>
import { mapMutations, mapState } from 'vuex';

export default {
  name: 'AppHeader',
  computed: {
    ...mapState(['userLoggedIn']),
  },
  methods: {
    ...mapMutations(['toggleAuthModal']),

    signout() {
      // passing the router object as part of payload to prevent dependency cycle
      this.$store.dispatch('signout', {
        router: this.$router,
        route: this.$route,
      }); // dispatch an action
    },
  },
};
</script>
